import { useContext } from "react";
import { useSelector } from "react-redux";

import { ComponentPropsContext, ComponentPropsContextApi } from "layouts/Flow Designer/context";
import SelectInput from "../SelectInput";
import { components } from "react-select";

const SelectWithDetailsInput = ({
  action,
  fieldValue,
  allowEditWorkflow,
  options,
  CustomOption
}) => {
  const { actionForm } = useContext(ComponentPropsContext);
  const { setActionForm, setFormErrors, filterValidationErrors } =
    useContext(ComponentPropsContextApi);
  const { currentSavedFlow } = useSelector((store) => store?.designer?.flows);
  const isFlowActive = currentSavedFlow?.shared_status === "active";

  const handleDropdownChange = (e, item) => {
    const { name } = item;
    let copy = { ...actionForm };

    copy = { ...actionForm, [name]: { ...actionForm[name], value: e.value } };
    setActionForm(copy);

    setTimeout(() => {
      filterValidationErrors(action.field);
    }, 100);
  };

  const handleDropDownBlur = () => {
    if (action.isRequired && !fieldValue) {
      setFormErrors((prev) => [...prev, action.field]);
    } else {
      filterValidationErrors(action.field);
    }
  };

  const OptionLogo = ({ logoUrl, LogoComponent, alt }) => {
    if (logoUrl) {
      return (
        <img src={logoUrl} alt={alt} width={20} height={20} style={{ objectFit: "contain" }} />
      );
    }

    if (LogoComponent) {
      return <LogoComponent width={20} height={20} aria-hidden />;
    }

    return null;
  };

  const DefaultOption = (props) => {
    return (
      <components.Option {...props}>
        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
          {(props.data?.logoUrl || props.data?.logoComponent) && (
            <OptionLogo
              logoUrl={props.data?.logoUrl}
              LogoComponent={props.data?.logoComponent}
              alt={props.data?.label}
            />
          )}
          <div style={{ fontSize: 14, fontWeight: "bold" }}>{props.data.label}</div>
        </div>
        {props.data.subLabel && <div style={{ fontSize: 12 }}>{props.data.subLabel}</div>}
      </components.Option>
    );
  };

  return (
    <SelectInput
      options={options.filter((option) => option.label !== undefined && option.label !== null)}
      action={action}
      fieldValue={fieldValue}
      handleChange={handleDropdownChange}
      onBlur={handleDropDownBlur}
      components={{ Option: CustomOption ?? DefaultOption }}
      disabled={isFlowActive || !allowEditWorkflow}
    />
  );
};

export default SelectWithDetailsInput;
